const n = Object.prototype.toString;
function i(t) {
  switch (n.call(t)) {
    case "[object Error]":
    case "[object Exception]":
    case "[object DOMException]":
    case "[object WebAssembly.Exception]":
      return !0;
    default:
      return r(t, Error);
  }
}
function c(t, e) {
  return n.call(t) === `[object ${e}]`;
}
function s(t) {
  return c(t, "Object");
}
function u(t) {
  return !!(t && t.then && typeof t.then == "function");
}
function r(t, e) {
  try {
    return t instanceof e;
  } catch {
    return !1;
  }
}
export {
  i as isError,
  r as isInstanceOf,
  s as isPlainObject,
  u as isThenable
};
